import { SET_SALE_TRACKING_STATUS } from '../../actions/actionTypes/sales';

export const initialState = {
    trackStatus: ''
};

type SalesState = typeof initialState;
interface ReducerAction {
    type: string;
    payload?: {
        status?: string;
    };
}

const sales = (state: SalesState | undefined, action: ReducerAction): SalesState => {
    const currentState = state ?? initialState;
    const { type, payload } = action;

    switch (type) {
        case SET_SALE_TRACKING_STATUS: {
            const { status = '' } = payload || {};
            return { trackStatus: status };
        }
        default: {
            return currentState;
        }
    }
};

export default sales;
